import { useMutation } from "react-query";
import { addLeasedEquipmentMake } from "../../../../../actions/Utilities/LeasedEquipmentMake";
import { toast } from "components/toastNotification";
import { IMake } from "../types";

const useAddMake = () => {
  const { mutate } = useMutation(
    (NewData: IMake) => addLeasedEquipmentMake(NewData),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Make Added Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Make Added Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire("Adding Make failed ", `Server Error: ${res}`, "error");
            break;
          case res == "The data already exists!":
            toast.fire(
              "Adding Make failed",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire("Adding Make failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Adding Make failed", res.Message, "error");
        }
      },

      onError: (error: any) => {
        toast.fire("Add Make failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddMake;
